import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LOADING_STATE } from "types/general";
import { COMPETITORS_SLICE_NAME, initialState } from "./constants";
import { getCompetitors } from "./controllers";
import { ICompetitorsFilters } from "./types";

const competitorsSlice = createSlice({
  name: COMPETITORS_SLICE_NAME,
  initialState,
  reducers: {
    setFilters: (
      state,
      action: PayloadAction<Partial<ICompetitorsFilters>>
    ) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompetitors.pending, (state) => {
        state.loadingState = LOADING_STATE.pending;
      })
      .addCase(getCompetitors.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loadingState = LOADING_STATE.fulfilled;
      })
      .addCase(getCompetitors.rejected, (state) => {
        state.loadingState = LOADING_STATE.rejected;
      });
  },
});

export const { setFilters } = competitorsSlice.actions;

export default competitorsSlice;
